import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DateRangeContainerComponent } from '../../date-range/date-range-container/date-range-container.component';

@Component({
  selector: 'app-dashboard-filters',
  standalone: true,
  imports: [CommonModule, FormsModule, DateRangeContainerComponent],
  templateUrl: './dashboard-filters.component.html',
  styleUrl: './dashboard-filters.component.scss'
})
export class DashboardFiltersComponent {
  @Input() dateFilter!: string;
  @Input() customFromDate!: string;
  @Input() customToDate!: string;
  @Input() storeFilter!: string;
  @Input() isLoading!: boolean;
  @Input() isLoadingFilters!: boolean;
  @Input() isLoadingStores!: boolean;
  @Input() dateFilters: any[] = [];
  @Input() stores: any[] = [];

  @Input() resolvedDateRange!: string;

  @Output() dateFilterChange = new EventEmitter<string>();
  @Output() customFromDateChange = new EventEmitter<string>();
  @Output() customToDateChange = new EventEmitter<string>();
  @Output() storeFilterChange = new EventEmitter<string>();
  @Output() onCustomSearch = new EventEmitter<void>();
  @Output() onDateFilterChange = new EventEmitter<void>();
  @Output() onStoreFilterChange = new EventEmitter<void>();

  /**
   * Check if the search button should be disabled
   * Returns true if loading OR if custom filter is selected but dates are invalid
   */
  get isSearchDisabled(): boolean {
    if (this.isLoading) {
      return true;
    }
    
    // If custom filter is selected, check if both dates are provided
    if (this.dateFilter === 'custom') {
      return !this.customFromDate || !this.customToDate;
    }
    
    return false;
  }

  /**
   * Get tooltip text for the search button
   */
  getSearchButtonTooltip(): string {
    if (this.isLoading) {
      return 'Loading...';
    }
    
    if (this.dateFilter === 'custom') {
      if (!this.customFromDate && !this.customToDate) {
        return 'Please select both From and To dates';
      } else if (!this.customFromDate) {
        return 'Please select a From date';
      } else if (!this.customToDate) {
        return 'Please select a To date';
      }
    }
    
    return 'Search with selected filters';
  }
}
